import React, { useEffect, useState } from "react";
import ttt from '../../../../assets/ttt.png';
import verified from '../../../../assets/verified.png';
import classNames from 'classnames';
import {
  ArrowRightOutlined,
  UserDeleteOutlined,
  EyeOutlined,
  ArrowsAltOutlined,
  SlidersOutlined,
  LikeOutlined,
  HeartOutlined,
  CheckCircleOutlined,
  FieldTimeOutlined,
  DeploymentUnitOutlined,
  ApartmentOutlined
} from '@ant-design/icons';
import { Button, Flex, Carousel, Col, Row, Modal } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import css from './Sections.module.css';
import { createResourceLocatorString } from "../../../../util/routes";
import { parse } from "../../../../util/urlHelpers";
import { useDispatch, useSelector } from "react-redux";
import { fetchSectionsData } from "../../../../ducks/strapi.duck";

function SectionMission(props) {

  const { history, routeConfiguration } = props;
  const currentLocation = useLocation();

  const [activeCard, setActiveCard] = useState(0); // Default active card is the first one

  const search = parse(currentLocation.search);
  const dispatch = useDispatch();

  const sectionsData = useSelector(state => state.strapi?.sectionsData) || [];

  const section = sectionsData?.sections?.filter(sec => sec?.heading === 'Why iParley?')[0] || {};
  const cardsSection = sectionsData?.sections?.filter(sec => sec?.heading === 'Why iParley Cards')[0] || {};

  useEffect(() => {
    dispatch(fetchSectionsData());
  }, [dispatch, search?.tag]);

  const handleMouseEnter = (index) => {
    setActiveCard(index);
  };

  // Define icons array to cycle through for cards
  const cardIcons = [
    <UserDeleteOutlined className={css.introCardIcon1} />,
    <SlidersOutlined className={css.introCardIcon2} />,
    <LikeOutlined className={css.introCardIcon3} />,
    <HeartOutlined className={css.introCardIcon4} />,
  ];

  // Extract dynamic data from Strapi or fallback to hardcoded data
  const cards = cardsSection?.data?.length > 0
    ? cardsSection.data.map((item, index) => ({
      icon: cardIcons[index % cardIcons.length],
      title: item.title,
      description: item.text,
    }))
    : [
      {
        icon: <UserDeleteOutlined className={css.introCardIcon1} />,
        title: "Verified Profiles & Partnerships",
        description: "Ensure authenticity with 100% verification of candidates, employers, and implementation suppliers, fostering trust and transparency.",
      },
      {
        icon: <SlidersOutlined className={css.introCardIcon2} />,
        title: "Streamlined Processes",
        description: "Simplify your hiring, job search, and partnership formation with an intuitive platform that matches you with the right opportunities or talent quickly.",
      },
      {
        icon: <LikeOutlined className={css.introCardIcon3} />,
        title: "Confidence in Choices",
        description: "Trust that every candidate, employer, and RFP has undergone rigorous vetting, allowing you to make informed and secure decisions.",
      },
      {
        icon: <HeartOutlined className={css.introCardIcon4} />,
        title: "Efficient & Targeted Connections",
        description: "Save time by connecting only with thoroughly vetted individuals or entities that align with your specific needs and goals.",
      },
    ];

  const redirectToSignupPage = () => {
    history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}));
  };

  const redirectToAboutUsPage = () => {
    history.push('/about');
  };

  return (

    <div className={css.introSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.introContainer}>
          <div className={css.introLeft}>
            <img src={ttt} alt='True Transparent Trusted' className={css.introImg} />
            <h2>Why iParley?</h2>
            <p>{section?.textBelowHeading}</p>

            {section?.data?.map((item, index) => {
              const icons = [
                <LikeOutlined />,
                <FieldTimeOutlined />,
                <HeartOutlined />,
                <DeploymentUnitOutlined />,
                <ApartmentOutlined />
              ];

              // Cycle through icons using modulo operator
              const icon = icons[index % icons.length];

              return (
                <div key={item.id} className={css.introPoints}>
                  <div className={css.introPointsImg}>
                    <div>{icon}</div>
                  </div>
                  <div className={css.introPoint}>
                    <h5>{item.title}</h5>
                    <p>{item.text}</p>
                  </div>
                </div>
              );
            })}

            <Flex gap="small" wrap className={css.introBtns}>
              <Button size="large" onClick={() => redirectToAboutUsPage()}>About Us</Button>
              <Button size="large" type="primary" icon={<ArrowRightOutlined />} iconPosition="end" onClick={() => redirectToSignupPage()}>Get Started</Button>
            </Flex>


            <div className={css.inDesktop}>
              <Carousel autoplay dots={false}>
                <div>
                  <Flex gap="middle" align="start" horizontal>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Identity</Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Driving License, Passport, Greencard</Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Education <span className={css.comingSoon}>Coming soon</span></Flex>
                  </Flex>
                </div>
                <div>
                  <Flex gap="middle" align="start" horizontal>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Work Experience <span className={css.comingSoon}>Coming soon</span></Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Work Authorization</Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Company Beneficial Owners</Flex>
                  </Flex>
                </div>
              </Carousel>
            </div>

            <div className={css.inMobile}>
              <Carousel autoplay dots={false}>
                <div>
                  <Flex gap="middle" align="start" horizontal>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Identity</Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Driving License, Passport, Greencard</Flex>
                  </Flex>
                </div>
                <div>
                  <Flex gap="middle" align="start" horizontal>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Education <span className={css.comingSoon}>Coming soon</span></Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Work Experience <span className={css.comingSoon}>Coming soon</span></Flex>
                  </Flex>
                </div>
                <div>
                  <Flex gap="middle" align="start" horizontal>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Work Authorization</Flex>
                    <Flex gap={5}>
                      <span><img src={verified} alt='verified' width="22" /></span> Company Beneficial Owners</Flex>
                  </Flex>
                </div>
              </Carousel>
            </div>

          </div>

          <div className={css.introRight}>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              {cards.map((card, index) => {

                let cardLink;
                switch (index) {
                  case 0: cardLink = 'more/verified-profiles';
                    break;
                  case 1: cardLink = 'more/processes';
                    break;
                  case 2: cardLink = 'more/choices';
                    break;
                  case 3: cardLink = 'more/connections';
                    break;
                }

                return (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} key={index}>
                    <Link to={cardLink}>
                      <div
                        className={`${css.introCard} ${activeCard === index ? css.active : ""}`}
                        onMouseEnter={() => handleMouseEnter(index)}
                      >
                        <div className={css.introCardOpen}>
                          <ArrowsAltOutlined />
                        </div>
                        <div className={css.introCardIcon}>{card.icon}</div>
                        <h4>{card.title}</h4>
                        <p>
                          {card.description} <EyeOutlined className={css.introCardIconEye} />
                        </p>
                      </div>
                    </Link>
                  </Col>
                );
              })}
            </Row>

          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionMission;
